export const NATIONAL_CREDITS = [
  'Kenny Loggins',
  'Francine Reed',
  'Tony Bennett',
  'Freddy Cole',
  'Kenny G.',
  'The Gap Band',
  'Travis Tritt',
  'Tinsley Ellis',
  'Bruce Hampton',
  'Gregg Allman',
  'Mac Frampton',
  'Charlie Daniels',
  'Hewy Lewis & The News',
  'Atlanta Symphony Orchestra',
  'Chicago',
  'Gladys Knight',
  'Robert Shaw',
  'Harold Melvin & The Blue Notes',
  'Oteil Burbridge',
  'Smokey Robinson',
  'Julian Lennon',
  'Roy Hargrove',
  'The Three Degrees',
  'Ben E. King',
  'Count Basie Orchestra',
  'The Jazz Crusaders',
  'Ohio Players',
  'Steps Ahead',
  'Russell Malone',
  'Joe Sample',
  'Mark O’Conner',
  'John Scofield',
  'Larry Coryell',
  'Eddie Harris',
  'Robben Ford',
  'Scott Henderson',
  'Frank Gambalie',
  'Marcus Miller',
  'Steve Morse',
  'Earth Wind and Fire',
  'Jimmy Buffet',
  'Danny and The Juniors',
  'Sean O’Rourke',
  'Mike Pope',
];

export const ATLANTA_CREDITS = [
  'Theresa Hightower',
  'Paul Mitchell',
  'Bob Page',
  'Alicia Rangel',
  'Dan Coy',
  'Patti Mac',
  'Larry Duff',
  'League of Decency',
  'Cody Marshal',
  'Bradford Rogers',
  'Tom Grose & The Varsity',
  'Robert Ray',
  'Jack Linge',
  'Diane Durrett',
  'Rupert’s Orchestra',
  'George Calhoon',
  'Jerry Farber',
  'Eric Quincy Tate',
  'Donnie McCormick',
  'Red Dog Blues Band',
  'Ritz Carlton Trio',
  'Edd Miller',
  'David Savage',
  'Marty Kearns',
  'Ned Suddreth',
  'Al Nicholson',
  'Lola Gully',
  'Chip Lunsford',
  'Woody Williams',
  'Dr. Dan',
  'Sean O’Rourke',
  'Jimmy Herring',
  'Scott Medder',
  'Jimmy Jackson',
  'Bear Facts Band',
  'Bobby Donaldson',
  'Marvin Taylor',
  'Yon-Rico Scott',
  'Freddie Jones',
  'Rick Bell',
  'Tommy Dean',
  'Wayne Sauls',
  'Bob Lewis',
  'Nico Lembo',
  'Anthony Baker',
  'Toni Byrd',
  'Jon liebman',
  'Francine Reed',
  'Nick Longo',
  'The Electromatics',
  'Dan Wall',
  'Larry Jackson',
  'Bobby Mobley',
  'Tomi Isobe',
  'Iris Farmer',
  'Greg Barrett',
  'William Noll',
  'Ritz Carlton Orchestra',
  'Jerry Lambert Trio',
  'Ricky Fargo',
  'Kodak Harrison',
  'Count Mombutu',
  'Eric Johnson',
  'Mocha',
  'Lou’s Blues Revue',
  'Steve Cunningham',
  'Trudy Lynn',
  'Jeff Sipe',
  'Mike Viel',
  'Ted Howe',
  'Sam Skelton',
  'Henry Parillia',
  'Jon Chalden',
  'Forrest Robinson',
  'Randy Honea',
  'Jerry Fields',
  'Keith Runfola',
  'Bill Norman',
  'Chris Burroughs',
  'Rick Hinkle',
  'Mike Kelly',
  'Robert Strickland',
  'Don Decenza',
  'Barry Thrasher',
  'Platinum',
  'Tony Carere',
  'Earl Ford',
  'Chris Hibbert',
  'Eric South',
  'Atlanta Beat',
  'Collin Agnew',
  'Rod Harris Jr.',
  'Buzz Amato',
  'Stephanie Pettis',
  'Tom Woods',
  'Andrew Black',
  'Eddie Horste',
  'Jez Graham',
  'John Robinson',
  'Bill Wilson',
  'Jimmy O’Neal',
  'Brian Stevens',
  'Rich Tatgenhorst',
  'Moxie',
  'Tom Knight',
  'Mose Davis',
  'Stevie Harris',
  'Bob Bevins',
  'Allen Cook',
  'Steve Vincent',
  'Steve Hulse',
  'Phil Smith',
  'Linda Sewell',
  'Sentimental Journey',
  'Jimmy O’Neal',
  'John Longo',
  'Peter Vogl',
  'Paul Fallet',
  'Brian Cole',
  'Chris Tonner',
  'Bill Anchel',
  'Barry Richmond',
  'Oliver Wood',
  'Cooper Tisdale',
  'Jody Worrell',
  'Franky-Lee',
  'Bill Stewart',
  'Jorge Alvarez',
  'Randy Hoexter',
  'Lee Goodness',
  'Kevin Harry',
  'Marcus Williams',
  'Jes Rosen',
  'Randy Hunter',
  'Gordon Vernick',
  'Brian Lopes',
  'Kofie Burbridge',
  'Justin Chesarek',
  'Henry C Conerway III',
];

export const DMV_CREDITS = [
  'Reginald Cyntje',
  'Harold Summey',
  'George Jones',
  'Elliot Levine',
  'Brent Birckhead',
  'Tedd Baker',
  'Mike Johnston',
  'Justine Miller',
  'Daniel Wallace',
  'Howie Jung',
  'Todd Simon',
  'Cubafros',
  'Neal Feldman',
  'Winston Johnson',
  'Richard  Seals',
  'Michael Joseph',
  'John Ware',
  'Irene Jalente',
  'Mike Kelleher',
  'Sweet Lu Olutosin',
  'Zack Pride',
  'Carly Harvey',
  'Jenny Langer',
  'Michael Raitzyk',
  'Donvonte McCoy',
  'Akua Allrich',
  'Glenn A Douglas',
  'Aaron L Myers II',
  'Jeff Antoniuk',
  'John David',
  'Landon Paddock',
  'Hope Udobi',
  'Joshua Davies',
  'Gabriel Wallace',
  'Joe Poppen',
  'DeAndrey Howard',
  'Jerry Lynn',
  'Paul Bangser',
  'Mark Meadows',
  'Elijah Jamal Balbed',
  'Marty Knepp',
  'Kevin Ellis',
  'Bobby Muncy',
  'Ian Dylan',
  'Tissa Khosla',
  'Will Spence',
  'Simone Baron',
  'Nick Mack',
  'Corey A. Wallace',
  'Isabelle de Leon',
  'Andrew Guterman',
  'Art McKinney',
  'Will Stephens',
  'Matthew Morgan',
  'Deante Willis',
  'Deirdre Jennings',
  'Julie Mack',
  'Tim Whalen',
  'Sol Roots',
  'Terence Arnet',
  'Lionel Lyles',
  'Herb Scott',
  'Flo Anito',
  'DeAndrey Howard',
  'Cecily Alexa Bumbray',
  'Dre King',
  'Tyler Leak',
  'Dante Pope',
  'Joseph Brotherton',
  'Brian Falkowski',
  'Thad Wilson',
  'Vic Chase',
  'Ryan Forrester',
  'Steve Arnold',
  'Jessica Lynn',
  'Eric Kennedy',
  'Jason Evan Barrett',
  'Mark Mosley',
  'Wes Crawford',
  'Sharon Clark Mevaa',
  'Ritse Adefolalu',
  'Jason Hammers',
  'Bryan McEntire',
  'Joseph Teachey',
  'Alex Brown',
  'Michael McFadden',
  'Nick Costa',
  'Anders Eliasson',
  'Darrell Jackson',
  'Ele Rubenstein',
  'Michael Benjamin',
  'Evan Samuels',
  'Glenn Wiser',
  'George V Johnson Jr',
  'Barry Moton',
  'Samuel Prather',
  'Tara Hofmann',
  'Clarence Ward III',
  'Genevieve Konecnik',
  'Pete Muldoon',
  'Joshua Bayer',
  'Victor Provost',
  'Barry Hart',
  'Tedd Baker',
  'Cristian Perez',
  'Imani-Grace Cooper',
  'Van Williamson',
  'Chris Urquiaga',
  'Shannon Gunn',
  'Dana-J Hawkins',
  'Burtrand Überall',
  'Matt Kelly',
  'Damon Foreman',
  'Don Stapleson',
];
